"use strict";

exports.__esModule = true;
var _CheckAccessRoute = require("./CheckAccessRoute");
Object.keys(_CheckAccessRoute).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _CheckAccessRoute[key]) return;
  exports[key] = _CheckAccessRoute[key];
});